
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 405 197","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMinYMin slice","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#115AA5","d":"M0 0h405v197H0z"}}),_c('g',{attrs:{"opacity":".2"}},[_c('path',{attrs:{"d":"M348.359 2.95v-88.536L41.109 91.486 348.36 268.56v-88.537l-153.64-88.536L348.359 2.95z","fill":"#B8C9DE"}}),_c('path',{attrs:{"d":"M348.359 180.022l153.64 88.537v-88.537l-153.64-88.536L501.999 2.95v-88.536L348.359 2.979v177.043z","fill":"#4780B2"}}),_c('path',{attrs:{"d":"M16.62 91.486c0-23.05-18.718-41.736-41.81-41.736C-48.28 49.75-67 68.436-67 91.486c0 23.049 18.72 41.735 41.81 41.735 23.092 0 41.81-18.686 41.81-41.735z","fill":"#B8C9DE"}})])])
          )
        }
      }
    